import { type FC } from 'react';

import CircularProgress from '@mui/material/CircularProgress';

import { Stack } from '@craft/ui/components/structural';
import { Typography } from '@craft/ui/components/typography';

export const LtiLoading: FC = () => (
  <Stack alignItems='center' direction='column'>
    <Typography>Loading...</Typography>
    <CircularProgress aria-label='Loading' />
  </Stack>
);
